import { TransactionSignature } from '@bbachain/web3.js'
import { fetchTxRequest } from 'actions'
import bs58 from 'bs58'
import { useEffect } from 'react'
import { HiOutlineLightBulb } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { RootState } from 'reducers'
import { AppDispatch } from 'store'
import { reportError } from 'utils'
import OverviewDetailCard from './components/overview-detail'
import InputDetail from './components/input-detail'
import InstructionDetailCard from './components/instruction-detail'

const TransactionDetails = () => {
	const { signature: txHash } = useParams()
	let signature: TransactionSignature | undefined

	try {
		const decoded = bs58.decode(txHash)
		if (decoded.length === 64) {
			signature = txHash
		}
	} catch (err) {
		reportError(err, {
			signature: txHash
		})
	}

	const dispatch = useDispatch<AppDispatch>()
	const { tx } = useSelector((state: RootState) => state.tx)

	useEffect(() => {
		dispatch(fetchTxRequest(signature))
	}, [dispatch, signature])

	if (!tx) {
		return null
	}

	return (
		<>
			<div className="mt-12 px-2.5 md:px-3 lg:px-5">
				<OverviewDetailCard data={tx} />
				<InputDetail data={tx} />
				<InstructionDetailCard instructionData={tx.transaction.message.instructions} />
				<div className="text-xsmall mb-10 flex items-center text-gray-700 dark:text-gray-300">
					<span className="text-large mb-1 mr-1">
						<HiOutlineLightBulb />
					</span>
					<span>
						A transaction refers to a cryptographically validated command that alters the state of the blockchain. Block
						explorers monitor the specifics of every transaction occurring within the network. Discover more about
						transactions in our
						<span className="ml-1 text-green-900">Knowledge Hub</span>.
					</span>
				</div>
			</div>
		</>
	)
}

export default TransactionDetails
